<div
  class="min-h-screen flex flex-col bg-age-cream text-age-green selection:bg-age-gold selection:text-white font-segoe"
>
  <header class="flex justify-center pt-10 pb-6">
    <img src="logo.png" alt="AGE Logo" class="w-48 md:w-56 h-auto" />
  </header>

  <main class="flex-1 flex flex-col items-center px-4 pb-20 text-center">
    <h1 class="font-bebas text-5xl md:text-6xl tracking-wider mb-4 mt-8">
      INSCRIPTION INDIVIDUELLE
    </h1>

    <p class="text-age-green text-lg mb-12 font-light">
      Rejoignez-nous pour échanger sur les avancées et l'avenir de la
      gérontologie. Choisissez votre type d'inscription ci-dessous.
    </p>

    <div
      class="flex flex-col md:flex-row gap-6 w-full max-w-5xl justify-center items-stretch mb-12"
    >
      <div
        class="flex flex-col items-center bg-white border border-age-beige rounded-[2rem] p-10 transition-all duration-300 hover:shadow-card flex-1"
      >
        <div
          class="w-20 h-20 bg-age-footer rounded-full flex items-center justify-center mb-8"
        >
          <lib-user></lib-user>
        </div>

        <h2 class="font-bebas text-3xl mb-4 tracking-wide">
          INSCRIPTION SEULE
        </h2>

        <p
          class="text-age-primary mb-8 text-[16px] leading-relaxed max-w-[200px]"
        >
          Inscription à l'événement sans hébergement
        </p>

        <button
          class="w-full bg-[#1E3A28] text-white font-semibold py-3 px-8 rounded-lg transition-colors hover:bg-opacity-90 cursor-pointer"
          (click)="navigate(true)"
        >
          Sélectionner
        </button>
      </div>

      <div
        class="flex flex-col items-center bg-white border border-age-beige rounded-[2rem] p-10 transition-all duration-300 hover:shadow-card flex-1"
      >
        <div
          class="w-20 h-20 bg-age-footer rounded-full flex items-center justify-center mb-8"
        >
          <lib-building></lib-building>
        </div>

        <h2 class="font-bebas text-3xl mb-4 tracking-wide">
          INSCRIPTION AVEC HÉBERGEMENT
        </h2>

        <p
          class="text-age-primary mb-8 text-[16px] leading-relaxed max-w-[250px]"
        >
          Inscription à l'événement avec réservation d'hébergement
        </p>

        <button
          class="w-full bg-[#1E3A28] text-white font-semibold py-3 px-8 rounded-lg transition-colors hover:bg-opacity-90 cursor-pointer"
          (click)="navigate(false)"
        >
          Sélectionner
        </button>
      </div>
    </div>

    <button
      (click)="goBack()"
      class="flex items-center gap-2 text-age-green/80 hover:text-age-green font-medium uppercase !text-sm tracking-widest transition-all duration-200 relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-age-green after:transition-all after:duration-300 hover:cursor-pointer hover:after:w-full"
    >
      <lib-arrow-left></lib-arrow-left>
      <span class="leading-none"> Retour à l'accueil </span>
    </button>
  </main>

  <lib-footer></lib-footer>
</div>
